import React, { useState } from "react";
import { HotkeyContext } from "./hotkeyContext.js";
export default function HotkeyContextProvider(props) {
    const [isLocked, setLock] = useState(false);
    function lock() {
        setLock(true);
    }
    function unlock() {
        setLock(false);
    }
    return (React.createElement(HotkeyContext.Provider, { value: { lock, unlock, isLocked } }, props.children));
}
